import * as React from 'react'

export const NumberFactsProgressHandler = React.lazy(
  () => import('@freckle/student/ts/math/number-facts/components/progress-page')
)
export const NumberBasicsQuestionDebuggerHandler = React.lazy(
  () => import('@freckle/student/ts/math/number-basics/components/debugger')
)
export const MathPracticeHintDebugHandler = React.lazy(
  () =>
    import('@freckle/student/ts/math/adaptive/components/hint-debug/math-practice-hint-debug-handler')
)
export const NumberBasicsBriefingPageHandler = React.lazy(
  () => import('@freckle/student/ts/math/number-basics/components/briefing')
)
export const NumberBasicsSessionHandler = React.lazy(
  () => import('@freckle/student/ts/math/number-basics/components/session')
)
export const MathMenuHandler = React.lazy(
  () => import('@freckle/student/ts/math/menu/components/math-menu')
)
export const MathAssessmentQuestionSessionHandler = React.lazy(
  () => import('@freckle/student/ts/math/assessment/components/index')
)
export const MathIblVideoHandler = React.lazy(
  () => import('@freckle/student/ts/math/ibl/components')
)
export const MathTargetedHandler = React.lazy(
  () => import('./../../../math/targeted/components/math-targeted-handler')
)
export const MathAdaptiveSessionOrDiagnosticHandler = React.lazy(
  () => import('@freckle/student/ts/math/adaptive/components/session-or-diagnostic-handler')
)
export const MathDiagnosticHandler = React.lazy(
  () => import('@freckle/student/ts/math/adaptive/components/diagnostic/handler')
)
export const MathAdaptiveTeacherAssignedSessionHandler = React.lazy(
  () => import('./../../../math/adaptive/components/teacher-assigned-session-handler')
)
export const MathAdaptiveDebugHandler = React.lazy(
  () => import('@freckle/student/ts/math/adaptive/components/debug-handler')
)
export const MathTargetedSelfAssignedHandler = React.lazy(
  () => import('@freckle/student/ts/math/targeted/components/self-assigned-handler')
)
export const FactPracticeSelfAssignedSessionHandler = React.lazy(
  () => import('@freckle/student/ts/math/fact-practice/components/self-assigned-handler')
)
export const FactPracticeTeacherAssignedSessionHandler = React.lazy(
  () => import('@freckle/student/ts/math/fact-practice/components/teacher-assigned-handler')
)
export const NumberFactsSelfAssignedHandler = React.lazy(
  () => import('@freckle/student/ts/math/number-facts/components/self-assigned-handler')
)
export const NumberFactsTeacherAssignedHandler = React.lazy(
  () => import('@freckle/student/ts/math/number-facts/components/teacher-assigned-handler')
)
export const MathDomainSelectionHandler = React.lazy(
  () => import('@freckle/student/ts/math/adaptive/components/domain-selection')
)
export const MathQuestionEditor = React.lazy(
  () => import('@freckle/student/ts/math/common/components/editor')
)
export const DomainBriefingHandler = React.lazy(
  () => import('@freckle/student/ts/math/adaptive/components/briefing')
)
export const MathDepthOfKnowledgeSessionHandler = React.lazy(
  () => import('@freckle/student/ts/math/depth-of-knowledge/components/adaptive')
)
export const MathTargetedDepthOfKnowledgeSessionHandler = React.lazy(
  () => import('@freckle/student/ts/math/depth-of-knowledge/components/targeted')
)
export const FocusSkillsPracticeHandler = React.lazy(
  () => import('@freckle/student/ts/focus-skills-practice/components/focus-skills-practice-handler')
)
export const HighSchoolCoursesHandler = React.lazy(
  () => import('@freckle/student/ts/math/high-school-courses')
)
export const CourseBriefingHandler = React.lazy(
  () => import('@freckle/student/ts/math/course-briefing')
)
export const DebugMathjaxHandler = React.lazy(
  () => import('@freckle/student/ts/math/common/components/debug/debug-mathjax')
)

export const DebugWorkedExampleHandler = React.lazy(
  () => import('@freckle/student/ts/math/internal/debuggers/worked-example')
)
